import { render, staticRenderFns } from "./cabecalho.vue?vue&type=template&id=221ab99a&scoped=true"
import script from "./cabecalho.vue?vue&type=script&lang=js"
export * from "./cabecalho.vue?vue&type=script&lang=js"
import style0 from "./cabecalho.vue?vue&type=style&index=0&id=221ab99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ab99a",
  null
  
)

export default component.exports